import { useMemo } from 'react';
import { useListOrgSettingsQuery } from '../api/tenantApi';

export type ApprovalModuleAccess = {
  customer: boolean;
  vendor: boolean;
  product: boolean;
  warehouse: boolean;
  procSales: boolean;
  procPurchase: boolean;
  anyEnabled: boolean;
  isLoading: boolean;
};

function settingOn(
  settings: Array<{ code: string; booleanValue?: boolean | null }> | undefined,
  code: string,
): boolean {
  const row = settings?.find((s) => s.code === code);
  return row?.booleanValue === true;
}

/**
 * Admin-managed APPROVAL_FLOW_* org settings.
 * Missing / false → module approval UI and enqueue are off.
 */
export function useApprovalModuleAccess(): ApprovalModuleAccess {
  const { data, isLoading } = useListOrgSettingsQuery();
  const settings = data?.listOrgSettings;

  return useMemo(() => {
    const customer = settingOn(settings, 'APPROVAL_FLOW_CUSTOMER');
    const vendor = settingOn(settings, 'APPROVAL_FLOW_VENDOR');
    const product = settingOn(settings, 'APPROVAL_FLOW_PRODUCT');
    const warehouse = settingOn(settings, 'APPROVAL_FLOW_WAREHOUSE');
    const procSales = settingOn(settings, 'APPROVAL_FLOW_PROC_SALES');
    const procPurchase = settingOn(settings, 'APPROVAL_FLOW_PROC_PURCHASE');
    return {
      customer,
      vendor,
      product,
      warehouse,
      procSales,
      procPurchase,
      anyEnabled:
        customer || vendor || product || warehouse || procSales || procPurchase,
      isLoading,
    };
  }, [settings, isLoading]);
}
